const useMarkerPosition = (values, type, data) => {
  const valuesArray = values.slice(0, values.length - 1)
  let position = null

  for (let i = 0; i < valuesArray.length; i++) {
    if (valuesArray[i] <= data) {
      position = i
    }
  }
  let normalizedPosition = 0

  if (type === 'AQI') {
    switch (data) {
      case '1':
        normalizedPosition = 25
        break
      case '2':
        normalizedPosition = 67
        break
      case '3':
        normalizedPosition = 110
        break
      case '4':
        normalizedPosition = 160
        break
      case '5':
        normalizedPosition = 200
        break
      case '6':
        normalizedPosition = 250
        break
      default:
        console.error('Invalid position for AQI')
        break
    }
  } else {
    normalizedPosition = (position * 45) + 25
  }

  return normalizedPosition
}

export default useMarkerPosition
